export default __webpack_public_path__ + "static/Fotolia_81347555_M-b2860004fc92eaa24231f3aa9ae2d735.jpg";